import React, { ReactNode, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { useAppDispatch } from '../store/hooks';
import { sessionChanged, sessionCleared } from '../store/store';
import { tradingApiSlice } from '../store/tradingApiSlice';
import { quoteStore } from './QuoteStore';

export const MarketDataProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { token, user } = useAuth();
  const dispatch = useAppDispatch();
  const userId = user?.id ?? null;
  const username = user?.username ?? null;
  const previousIdentity = useRef<string | null>(null);

  useEffect(() => {
    const nextIdentity = token && userId !== null ? `${userId}:${token}` : null;

    if (token && userId !== null) {
      dispatch(sessionChanged({ userId, username }));
      quoteStore.configure(token, String(userId));
    } else {
      dispatch(sessionCleared());
      quoteStore.configure(null, null);
    }

    // Do not reset on initial mount: account query subscriptions may already
    // be active, and deleting their first successful response can strand the
    // page in `isLoading` (especially under React StrictMode). Reset only when
    // an established identity genuinely changes or is cleared.
    if (
      previousIdentity.current !== null
      && previousIdentity.current !== nextIdentity
    ) {
      dispatch(tradingApiSlice.util.resetApiState());
    }
    previousIdentity.current = nextIdentity;
  }, [dispatch, token, userId, username]);

  return <>{children}</>;
};
